import {Container} from "react-bootstrap";
import {LastRegisteredUsers} from "../components/generic/users/LastRegisteredUsers";
import {SearchUsers} from "../components/generic/users/SearchUsers";

const Home = () => {

    return (
        <Container>
            <h3>Last registered users</h3>
            <LastRegisteredUsers count={10}/>
            <h3>Search users</h3>
            <SearchUsers />
        </Container>
    );
};

export default Home;
